import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WarrantyPage } from '@/features/owner/warranty-page';

const searchSchema = z.object({
  claim: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/closeout/warranty')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <WarrantyPage projectId={projectId} focus={search.claim} />;
}
